import React from 'react';
import {Card, Grid, InputAdornment} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import TextField from '@/components/form/text_field';

const useStyles = makeStyles({
  root: {
    padding: 15,
    marginTop: 10,
  },
  grid: {
    '& > *': {
      marginBottom: 10,
    },
  },
});

const WriteLimitCard = () => {
  const classes = useStyles();

  const WriteLimitToolTip = 'Set a limit for write speed, in MiB/sec. ' +
  'The limit is enforced only while the volume usage exceeds the caution '+
  'threshold. As additional space is consumed, the write limit is reduced. '+
  'The limit is no longer enforced if used space drops below the caution '+
  'threshold';
  return (
    <Card className={classes.root}>
      <Grid container spacing={2} className={classes.grid}>
        <Grid item xs={6}>
          <TextField
            parse={(value) => {
              const number = Number(value);
              if (!value && value !== '0') {
                return null;
              } else if (isNaN(number)) {
                return value;
              } else {
                return number;
              }
            }}
            name='writeLimit'
            label='Write Limit'
            InputProps={{
              endAdornment: <InputAdornment position='end'>MiB/sec</InputAdornment>,
            }}
            tooltip={WriteLimitToolTip} />
        </Grid>
      </Grid>
    </Card>
  );
};

export default WriteLimitCard;
